module.exports = __webpack_public_path__ + "img/arrowOpened.c35ea5b3.svg";